import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  CustomFieldExtensionSchema,
} from '@backstage/plugin-scaffolder-react';
import {
  SystemComponentPicker,
  SystemComponentPickerSchema,
} from './SystemComponentPicker';

export const SystemComponentPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SystemComponentPicker',
    component: SystemComponentPicker,
    schema: SystemComponentPickerSchema as CustomFieldExtensionSchema,
  }),
);
